import { FC } from 'react';
import styled from 'styled-components';
import { BaseLayout } from '../Layout/BaseLayout';
import { IBaseLayoutProps } from '../Layout/IBaseLayoutProps';

const LayoutElement = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  flex-flow: row wrap;
  overflow: auto;

  & > * {
    min-width: 300px;
    max-width: 500px;
    margin-right: 50px;
    margin-bottom: 20px;
  }
`;

type IProps = IBaseLayoutProps;

export const TwoColumnLayout: FC<IProps> = props => {
  return (
    <BaseLayout {...props} data-testid="TwoColumnLayout">
      <LayoutElement>{props.children}</LayoutElement>
    </BaseLayout>
  );
};
